import { Heading } from "@chakra-ui/react";
import { useContext } from "react";
import { AppContext } from "../AuthContext/AuthContext";
import Category from "./Component/Category";
import Poster from "./Component/Poster";

const Home = () => {
  const { isAuth } = useContext(AppContext);
  let width = window.innerWidth;

  return (
    <div>
      {isAuth && width > "1000" && (
        <Heading color="cyan.500" mt={6}>
          Please Login to Go To Any Page
        </Heading>
      )}
      <Poster />
      <Category />
    </div>
  );
};

export default Home;
